<mat-toolbar color="primary">
  <a class="header-brand-link" routerLink="/map" aria-label="Brand Logo">
    <span class="header-brand-name">
      Fresh-Tap
    </span>
   
  </a>
  <div class="spacer"></div>
  <mat-nav-list>
    <mat-list-item>
      <a matLine routerLink="/map">Map</a>
    </mat-list-item>
    <mat-list-item>
      <a matLine routerLink="/about">About</a>
    </mat-list-item>
  </mat-nav-list>

  <mat-select
    [value]="unitConversionService.CurrentUnit"
    (selectionChange)="onUnitChanged($event)"
  >
    <mat-option value="km"> km </mat-option>
    <mat-option value="mi"> mi </mat-option>
  </mat-select>
</mat-toolbar>
